export const SERVICE_INPROGRESS =`LOADING`;

export const serviceInProgress=(params)=>({
    type:SERVICE_INPROGRESS,
    value:params,
    });
    